import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import * as tripActions from '../actions';
import { map, exhaustMap, catchError, mergeMap, tap } from 'rxjs/operators';
import { UsersService } from '../../../users.service';
@Injectable()
export class TripEffect {
  constructor(private actions$: Actions, private userService: UsersService) { }

  getTrip$ = createEffect(() =>
    this.actions$.pipe(
      ofType(tripActions.getTrip),
      exhaustMap((action) =>
        this.userService.getAll(action?.queryParams).pipe(
          map((response) => tripActions.getTripSuccess({ data: response })),
          catchError((error: any) => of(tripActions.getTripFailure(error)))
        )
      )
    )
  );
  createTrip$ = createEffect(() =>
    this.actions$.pipe(
      ofType(tripActions.createTrip),
      exhaustMap((action) =>
        this.userService.save(action.data).pipe(
          map((response) => tripActions.createTripSuccess({ data: response })),
          catchError((error: any) => of(tripActions.createTripFailure(error)))
        )
      )
    )
  );
  deleteTrip$ = createEffect(() =>
    this.actions$.pipe(
      ofType(tripActions.deleteTrip),
      exhaustMap((action) =>
        this.userService.delete(action.id).pipe(
          map((response) => tripActions.deleteTripSuccess({ id: response })),
          catchError((error: any) => of(tripActions.deleteTripFailure(error)))
        )
      )
    )
  );

  getByIdTrip$ = createEffect(() =>
    this.actions$.pipe(
      ofType(tripActions.getTripById),
      exhaustMap((action) =>
        this.userService.getById(action.id).pipe(
          map((response) => tripActions.getTripByIdSuccess({ data: response })),
          catchError((error: any) => of(tripActions.getTripByIdFailure(error)))
        )
      )
    )
  );

  // getCitiesByDestionationTrip$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(tripActions.getCitiesByDestionation),
  //     exhaustMap((action) =>
  //       this.userService.getCitiesByDsetinationIds(action.data).pipe(
  //         map((response) =>
  //           tripActions.getCitiesByDestionationSuccess({ data: response })
  //         ),
  //         catchError((error: any) =>
  //           of(tripActions.getCitiesByDestionationFailure(error))
  //         )
  //       )
  //     )
  //   )
  // );
}
